import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared';
import { HomeMaterialModule } from '../home-material/home-material.module';

import { AccountDetailsComponent } from './account-details.component';
import { AccountActivityModule } from './account-activity/account-activity.module';
import { ParticipationModule } from './participation/participation.module';
import { AccountRewardsModule } from './rewards/account-rewards.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    HomeMaterialModule,
    AccountActivityModule,
    ParticipationModule,
    AccountRewardsModule,
  ],
  declarations: [
    AccountDetailsComponent,
  ],
  exports: [
    AccountDetailsComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class AccountDetailsModule {}
